// @flow

import styled from 'styled-components';

export const Link = styled.a`
  text-decoration: none;
  color: rgb(35, 151, 212);

  &:hover {
    filter: brightness(115%);
  }
`;
